import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=047a462d&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('047a462d')) {
      api.createRecord('047a462d', component.options)
    } else {
      api.reload('047a462d', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=047a462d&", function () {
      api.rerender('047a462d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-45L4qOw433b4x/JS/pricehelp.vue"
export default component.exports